import myData from '../_json/spanish.json';
export default function Messages (){
    const allMessages = myData
    return allMessages
}